// extracted by mini-css-extract-plugin
export default {"root":"NewPasswordView_root__ZR68b","formWrapper":"NewPasswordView_formWrapper__5VIHZ"};